import { useGetProgramStoresQuery } from '@graphql/generated/graphql';
import logger from 'src/utils/logger';
import { usePageLoaded } from 'src/hooks/usePageLoaded';
import { useEffect } from 'react';

interface Store {
  store: string;
  label: string;
}
const useGetProgramStores = () => {
  const pageLoaded = usePageLoaded();
  const { data, error, isError } = useGetProgramStoresQuery(
    {},
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      enabled: pageLoaded,
    },
  );

  useEffect(() => {
    if (isError) {
      const { message, name } = error as Error;
      void logger.error(`Error occurred while retrieving list of stores: ${name}: ${message}`);
    }
  }, [isError, error]);
  const storeList: Store[] =
    data?.getProgramStores.stores
      ?.map((store) => ({
        store: store.storeId,
        label: `${store.storeId}   [${store.warehouseId}]`,
      }))
      .sort((s1: Store, s2: Store) => s1.label.localeCompare(s2.label)) || [];
  return storeList;
};

export default useGetProgramStores;
